import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-tire-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Tire Options</h2>
        </div>
        <div class="flex-fill d-flex flex-column">
            <div class="card">
                <div class="card-body">
                    <dx-form *ngIf="entity" [formData]="entity" validationGroup="validationGroup">
                        <dxi-item itemType="group">
                            <dxi-item dataField="name">
                                <dxi-validation-rule type="required"> </dxi-validation-rule>
                            </dxi-item>
                            <dxi-item dataField="value">
                                <dxi-validation-rule type="required"> </dxi-validation-rule>
                            </dxi-item>
                            <dxi-item [label]="{ text: 'Spare Tire Part' }">
                                <div *dxTemplate>
                                    <dx-select-box [(value)]="entity.spareTireId" [items]="spareTires" [valueExpr]="'id'" [displayExpr]="'displayName'"> </dx-select-box>
                                </div>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" [caption]="'Pricing'" [colCount]="2">
                            <dxi-item dataField="upgradePrice" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00' }"> </dxi-item>
                            <dxi-item dataField="singleFenderPrice" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00' }"> </dxi-item>
                            <dxi-item dataField="tandemFenderPrice" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00' }"> </dxi-item>
                            <dxi-item dataField="tripleFenderPrice" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00' }"> </dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-danger" (click)="save()">Save</button>
            <button class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    standalone: false,
})
export class TireDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    entity: any;
    entityType: string;
    displayOrder: number;
    validationGroup: 'validationGroup';
    spareTires: any[] = [];

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        await this.getData();
        let spareTires = (await this.uow.getPartOptions()) as any[];
        const pp1029 = await this.uow.getPartByPartNumber('PP-1029');
        const pp1030 = await this.uow.getPartByPartNumber('PP-1030');
        const pp1031 = await this.uow.getPartByPartNumber('PP-1031');
        const pp1262 = await this.uow.getPartByPartNumber('PP-1262');
        const pp1350 = await this.uow.getPartByPartNumber('PP-1350');
        spareTires.push(pp1029, pp1030, pp1031, pp1262, pp1350);
        // spareTires.forEach((spare) => {
        //     spare.displayName = `${spare.partNumber} - ${spare.description}`;
        // });
        this.spareTires = spareTires;
    }

    async getData() {
        if (!this.entity) {
            this.entity = this.uow[this.entityType].createEntity({
                displayOrder: this.displayOrder,
            }) as any;
        }
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true, value: this.entity });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('validationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('validationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
